module.exports = __webpack_public_path__ + "static/img/25.c4b6fdc1.gif";